export default __webpack_public_path__ + "static/media/party.ab69c091.svg";